import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    MeetingsInfo,
    MeetingsInfoWrapper,
} from 'src/domains/sportsbook/webview/components/meetingsAntePostAndSpecials/Meetings.style';
import { SportRacesTypeParamType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    groupEventsSpecials,
    MeetingsState,
} from 'src/domains/sportsbook/webview/components/meetingsAntePostAndSpecials/MeetingsState';
import { TableSportsList } from 'src/domains/sportsbook/webview/components/meetingsAntePostAndSpecials/MeetingsGroup';
import { MeetingsRaceCard } from 'src/domains/sportsbook/webview/components/meetingsAntePostAndSpecials/MeetingsRaceCard';
import { MeetingsSpecialsLoader } from 'src/domains/sportsbook/webview/components/meetings/loaders/MeetingsLoaders';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropType {
    eventId: EventId | null;
    filterType: SportRacesTypeParamType | null;
    isLoading: boolean;
    shared: boolean;
    sport: 'horseracing' | 'greyhoundracing';
}

export const MeetingsSpecials = observer('MeetingsSpecials', (props: PropType) => {
    const { eventId, isLoading, filterType, sport } = props;

    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const [state] = React.useState(() => new MeetingsState(common, () => sport));

    const eventsSpecials = state.collectionEvents;
    const events = groupEventsSpecials(eventsSpecials);
    const event = eventId?.getEventModel() ?? null;

    if (isLoading) {
        return (
            <MeetingsInfoWrapper variant={configState.componentVariants.sportsbookVariant}>
                <MeetingsInfo variant={configState.componentVariants.sportsbookVariant}>
                    <MeetingsSpecialsLoader />
                </MeetingsInfo>
            </MeetingsInfoWrapper>
        );
    }

    if (eventsSpecials.length === 0) {
        return (
            <MeetingsInfoWrapper variant={configState.componentVariants.sportsbookVariant}>
                <MeetingsInfo variant={configState.componentVariants.sportsbookVariant}>
                    <I18n
                        langKey='events.ante-post.empty'
                        defaultText='There are no races available at the moment. Please check again later.'
                    />
                </MeetingsInfo>
            </MeetingsInfoWrapper>
        );
    }

    const isSpecialsEvent = event !== null && filterType === 'specials';

    if (isSpecialsEvent) {
        return (
            <MeetingsRaceCard
                markets={event.markets}
                section='specials'
            />
        );
    }

    return (
        <TableSportsList
            events={events}
            section='specials'
        />
    );
});
